import { useMatrixVariantsContext } from '@app/components/products/ProductMatrix/context';
import { getIsOnSale } from '@app/logic/price';
import { cn } from '@app/utils/cn';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { Product } from '@typings';
import { useTranslation } from 'react-i18next';

import { VariantName } from './VariantName';

interface Props {
  variant: Product.Standard;
  shouldShowRrp?: boolean;
}

export const VariantInfo = ({ variant, shouldShowRrp = true }: Props) => {
  const { t } = useTranslation(['common']);
  const { pricePerVariant } = useMatrixVariantsContext();
  const { rrp, rrpAsNumber, price, priceAsNumber, discountPercent, showAsOnSale } = pricePerVariant[variant.variant] ?? {};

  const isDiscounted = getIsOnSale(showAsOnSale, discountPercent);

  const priceValue = isDefined(priceAsNumber) ? price : null;
  const rrpValue = shouldShowRrp && isDefined(rrpAsNumber) ? rrp : null;

  const skuLabel = isEmpty(variant.sku) ? '-' : variant.sku;

  return (
    <div className="flex flex-col justify-center body-4 lg:max-w-64">
      <VariantName variant={variant} />
      <div className="flex gap-1">
        <span
          className={cn('whitespace-nowrap', {
            'text-error-45': isDiscounted,
          })}
        >
          {priceValue}
        </span>
        {isDefined(rrpValue) && (
          <span className="overflow-hidden text-ellipsis whitespace-nowrap text-neutral-60">
            ({t('common:rrp')}: {rrpValue})
          </span>
        )}
      </div>

      <span className="line-clamp-2 overflow-hidden text-ellipsis text-neutral-60 body-4 md:line-clamp-1">
        {t('common:art_no', { artNo: skuLabel })}
      </span>
    </div>
  );
};
